module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig01"
    }
  }, [_vm._v("Woodlake, Franklin County, Kentucky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig02"
    }
  }, [_vm._v("Madeline and Julia McDowell at Woodlake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig03"
    }
  }, [_vm._v("Madeline McDowell, aged fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig04"
    }
  }, [_vm._v("Henry Clay McDowell Sr. on his Ashland estate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig05"
    }
  }, [_vm._v("Miss Porter’s School in Farmington, Connecticut")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#fig06"
    }
  }, [_vm._v("The McDowell sisters—Julia, Nettie, and Madeline")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#fig07"
    }
  }, [_vm._v("Boot or brace believed to have belonged to Madeline McDowell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02#fig08"
    }
  }, [_vm._v("Madeline McDowell, early 1890s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("McDowell family and friends on the steps at Ashland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desha Breckinridge, 1920")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry Clay McDowell Sr.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Madeline McDowell Breckinridge at Ashland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The home of Madge and Desha Breckinridge at 337 Linden Walk, Lexington")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sophonisba P. Breckinridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Students in a classroom at Lincoln School")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from a pamphlet of the Kentucky Equal Rights Association")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outdoor School on the roof of Lincoln School")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laura Clay, founder of the Kentucky Equal Rights Association")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banner of the Kentucky Equal Rights Association")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anne “Nannie” Clay McDowell at Ashland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family gathering at Ashland, May 19, 1917")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magdalen Harvey McDowell at Ashland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Portrait of Madeline McDowell Breckinridge by Dixie Selden, 1920")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Governor Edwin P. Morrow signs Kentucky’s ratification of the Nineteenth Amendment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Madeline McDowell Breckinridge by E. Sophonisba Hergersheimer, 1920")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01#fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desha Breckinridge")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 78
// module chunks = 0